<template>
  <AuthBox :auth="false">
    <h1 class="auth-title">{{ $t('content.forgot_title') }}</h1>
    <div class="auth-subtitle mb-6">{{ $t('content.forgot_subtitle') }}</div>
    <form @submit.prevent="submit">
      <form-group :name="$t('form.email')" :validator="$v.form.email">
        <template slot-scope="{ attrs }">
          <v-text-field v-model="form.email" v-bind="attrs" :label="$t('form.email')" @input="$v.form.email.$touch()" @blur="$v.form.email.$touch()">
            <template #prepend-inner>
              <svg-icon icon="email" class="primary--text mr-3" />
            </template>
          </v-text-field>
        </template>
      </form-group>
      <v-row>
        <v-col>
          <v-btn block color="primary" class="btn-primary-custom mt-4" outlined @click="backToLogin">{{ $t('back') }}</v-btn>
        </v-col>
        <v-col>
          <v-btn block color="primary btn-primary-custom" type="submit" class="mt-4" :loading="loading">{{ $t('send') }}</v-btn>
        </v-col>
      </v-row>
    </form>
  </AuthBox>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import FormGroup from '@/components/base/FormGroup';
import AuthBox from '@/components/base/AuthBox';

export default {
  name: 'AuthForgotPass',
  components: {
    AuthBox,
    FormGroup
  },
  validations: {
    form: {
      email: { required, email }
    }
  },
  data: () => ({
    loading: false,
    form: {
      email: ''
    }
  }),
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      this.loading = true;
      this.$axios
        .post('/api/auth/forgot_password', { email: this.form.email })
        .then(() => this.$router.push({ name: 'AuthForgotPassSuccess', replace: true }), localStorage.setItem('notif', 0))
        .finally(() => (this.loading = false));
    },
    backToLogin() {
      this.$router.push({ name: 'AuthLogin' });
    }
  },
  created() {
    this.$store.commit('Auth/SET_GOOGLE_AUTH_CLEAR');
  }
};
</script>
